import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@node_modules/@angular/platform-browser';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
  public message?: string;
  public title!: string;
  public cancelButtonText?: string;
  public confirmButtonText: string = 'CONFIRM';
  public showCloseButton = true;
  public isLoad: boolean = false;
  public html?: SafeHtml;

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (!this.data.html) {
      this.message = this.data?.message || this.data;
    } else {
      this.html = this.sanitizer.bypassSecurityTrustHtml(this.data.html);
    }

    this.title = this.data?.title || 'ATTENTION';

    if (this.data.cancelButtonText) this.cancelButtonText = this.data.cancelButtonText;

    if (this.data.confirmButtonText) this.confirmButtonText = this.data.confirmButtonText;

    if (this.data.showCloseButton !== undefined) {
      this.showCloseButton = this.data.showCloseButton;
    }
  }

  public close() {
    this.dialogRef.close();
  }

  public cancel() {
    this.dialogRef.close(false);
  }

  public confirm(isLoad: boolean = false) {
    if (this.isLoad) return;

    this.isLoad = isLoad;
    if (this.data.cbConfirm) {
      return this.data.cbConfirm();
    }

    this.dialogRef.close(true);
  }
}
